import { Login } from "./components/auth/LoginPage";
import { PricingPage } from "./components/pricing/PricingPage";
import { PasswordReminder } from './components/auth/PasswordReminder';
import { PasswordReset } from './components/auth/PasswordReset';
import { ProtectedRoute } from "./components/common/ProtectedRoute";

const AppRoutes = [
	{
		index: true,
		element:
			<ProtectedRoute>
				<PricingPage />
			</ProtectedRoute>
	},
	{
		path: '/login',
		element: <Login />
	},
	{
		path: 'forgotCredentials',
		element: <PasswordReminder />
	},
	{
		path: 'passwordReset',
		element: <PasswordReset />
	}
];

export default AppRoutes;
